export default "__VITE_ASSET__JKfeMQRK__"